<template>
    <div class="scope-arrangement-setting scope-arrangements">
        <div class="top-bar background-white box-shadow-small border-radius">
            <el-row type="flex" align="middle">
                <el-col :span="10">
                    <el-checkbox :indeterminate="isIndeterminate" v-model="allChecked" @change="toggleAllChecked"
                                 class="ml-10">全选
                    </el-checkbox>
                    <el-checkbox-group style="display: inline-block;" v-model="checkedPhase"
                                       @change="handleCheckedChange">
                        <el-checkbox label="0" class="ml-10">全选一面</el-checkbox>
                        <el-checkbox label="1" class="ml-10">全选二面</el-checkbox>
                        <el-checkbox label="2" class="ml-10">全选三面</el-checkbox>
                        <el-checkbox label="3" class="ml-10">全选四面</el-checkbox>
                    </el-checkbox-group>
                    <el-button @click="addNextPhase" style="margin-left: 8px;">全部追加一个面试阶段</el-button>
                </el-col>
                <el-col :span="14" class="text-right">
                    <el-button @click="saveSelectedData" type="primary" style="margin-right: 8px;" title="会自动忽略已评价记录">
                        保存已选中数据
                    </el-button>
                    <arrange-common @sendEmail="sendEmail"></arrange-common>
                    <el-button @click="saveToMine" style="margin-left: 8px;">保存到我的面试</el-button>
                    <el-button @click="$router.back()" style="margin-left: 8px;" icon="el-icon-arrow-left">返回</el-button>
                </el-col>
            </el-row>
            <el-row class="text-center multi-setting" :gutter="20">
                <el-col :span="4">
                    <p class="label">面试阶段</p>
                    <div class="betch">
                        <el-select size="medium" class="betch-left" v-model="topObj.turnType" placeholder="请选择">
                            <el-option label="一面" value="0,0"></el-option>
                            <el-option label="一面(HR面)" value="0,1"></el-option>
                            <el-option label="二面" value="1,0"></el-option>
                            <el-option label="二面(HR面)" value="1,1"></el-option>
                            <el-option label="三面" value="2,0"></el-option>
                            <el-option label="三面(HR面)" value="2,1"></el-option>
                            <el-option label="四面" value="3,0"></el-option>
                            <el-option label="四面(HR面)" value="3,1"></el-option>
                        </el-select>
                        <a href="javascript:;" class="betch-btn" @click="setBetchCol('turnType')"></a>
                    </div>
                </el-col>
                <el-col :span="5">
                    <p class="label">面试时间</p>
                    <div class="betch">
                        <el-date-picker size="medium" class="betch-left" v-model="topObj.interviewDate" format="yyyy-MM-dd HH:mm" type="datetime"
                                        placeholder="选择日期时间"></el-date-picker>
                        <a href="javascript:;" class="betch-btn" @click="setBetchCol('interviewDate')"></a>
                    </div>
                </el-col>
                <el-col :span="5">
                    <p class="label">面试形式</p>
                    <div class="betch">
                        <el-select size="medium" class="betch-left" v-model='topObj.interviewType' placeholder='请选择'>
                            <el-option v-for='(item, index) in selectMap.WB_INTERVIEW_TYPE' :key='index'
                                       :label='item.text'
                                       :value='item.value'></el-option>
                        </el-select>
                        <a href="javascript:;" class="betch-btn" @click="setBetchCol('interviewType')"></a>
                    </div>
                </el-col>
                <el-col :span="5">
                    <p class="label">面试官</p>
                    <div class="betch">
                        <user-search class="betch-left" ref="topInterviewer" v-model="topObj.masterInterviewer"
                                     holder="面试官" style="width: 60%;display: inline-block;"></user-search>
                        <a href="javascript:;" class="betch-btn" @click="setBetchCol('masterInterviewer')"></a>
                    </div>
                </el-col>
                <el-col :span="5">
                    <p class="label">面试地点</p>
                    <div class="betch">
                        <el-input size="medium" class="betch-left" v-model.trim="topObj.interviewPlace" placeholder="请输入内容"
                                  style="width: 60%"></el-input>
                        <a href="javascript:;" class="betch-btn" @click="setBetchCol('interviewPlace')"></a>
                    </div>
                </el-col>
            </el-row>
        </div>
        <div class="arrangement-list" v-if="listData">
            <div v-for="(item, index) in listData" :key="index" class="box-shadow-small border-radius mt-20">
                <arrangement-item class="background-white mb-10"
                                  ref="arrangement"
                                  :isSingle="false"
                                  @sendEmail="sendEmail"
                                  @checkbox="counterCheckbox"
                                  :init="item">
                </arrangement-item>
            </div>
        </div>
        <email-sender ref="sendEmail"></email-sender>
    </div>
</template>

<script>
    import ArrangementItem from './arrangementItem'
    import ArrangeCommon from './arrangeCommon'
    import EmailSender from '../operation/interviewerEmailDialog'
    import selectMapMixin from 'mixins/selectMapMixin'
    import UserSearch from 'components/userSelect/searchDownList'
    import _ from 'underscore'

    export default {
        components: {
            ArrangementItem, EmailSender, ArrangeCommon, UserSearch
        },
        created () {
            this.getData()
        },
        mixins: [selectMapMixin],
        data () {
            return {
                listData: null,
                allChecked: false,
                isIndeterminate: false,
                checkedPhase: [],
                counter: 0,
                topObj: {
                    turnType: '',
                    interviewDate: '',
                    interviewType: '',
                    masterInterviewer: '',
                    interviewPlace: ''
                }
            }
        },
        computed: {
            ids () {
                return this.$route.params.ids
            }
        },
        watch: {
            $route: function () {
                this.getData()
            }
        },
        methods: {
            setBetchCol (attr) {
                let val = this.topObj[attr], names = ''
                if (attr === 'masterInterviewer') {
                    let list = this.$refs.topInterviewer.getSelected()
                    val = list.map(item => item.id).join(',')
                    names = list.map(item => item.name).join('，')
                }
                if (val === '') {
                    this.$message({
                        message: '数据不能为空',
                        type: 'warning'
                    })
                } else {
                    let selecteds = {}
                    let hasSelectedRow = false
                    this.$refs.arrangement.forEach((item, index) => {
                        let tableSelected = item.getSelected()
                        if (tableSelected.length) {
                            hasSelectedRow = true
                            selecteds[index] = tableSelected
                        }
                    })
                    if (hasSelectedRow === false) {
                        this.$message({
                            message: '请勾选面试阶段',
                            type: 'warning'
                        })
                    } else {
                        for (let key in selecteds) {
                            let view = this.$refs.arrangement[key]
                            view.updateColData(selecteds[key], attr, val, names)
                        }
                    }
                }
            },
            counterCheckbox (value) {
                value ? this.counter++ : this.counter--
                this.allChecked = (this.counter === this.listData.length)
            },
            addNextPhase () {
                this.$refs.arrangement.forEach(item => {
                    let rowData = item.addInterview()
                    item.$refs.table.toggleRowSelection(rowData, true)
                })
            },
            getData () {
                if (String(this.$route.params.ids) === '-1') {
                    this.listData = []
                    return false
                }
                this.$axios.get(`/resumePosition/interviewRecord/recordDetail.api?rpIds=${this.ids}`).then(res => {
                    let list = res.result.list
                    list.forEach(item => {
                        item.id = item.rpId || ''
                        item.list.forEach(form => {
                            form.turnType = [form.turn, form.isHr].join(',')
                        })
                    })
                    this.listData = list
                }).catch(console.error)
            },
            saveToMine () {
                this.$prompt('请输入面试安排记录名称', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    inputPattern: /^[\S]{1,20}$/,
                    inputErrorMessage: '不能为空，不能空字符开头，长度不能超过20'
                }).then(({value}) => {
                    this.$axios.post('/resumePosition/interviewRecord/insert.api', {
                        recordName: value,
                        rpIds: this.$route.params.ids
                    }, {
                        'X-showMessage': true
                    }).catch(() => {
                    })
                }).catch()
            },
            toggleAllChecked (event) {
                this.isIndeterminate = false
                this.checkedPhase = event ? ['0', '1', '2', '3'] : []
                this.$refs.arrangement.forEach(item => {
                    item.toggleAllSelect(this.allChecked)
                })
            },
            handleCheckedChange (checkedArr) {
                let checkedCount = checkedArr.length
                this.allChecked = checkedCount === 4
                this.isIndeterminate = checkedCount > 0 && checkedCount < 4

                this.$refs.arrangement.forEach(item => {
                    item.toggleAllSelect(this.allChecked, this.checkedPhase)
                })
            },
            saveSelectedData () {
                let list = []
                let selecteds = []
                let hasError = false
                let map = {}
                let tips = ''
                this.$refs.arrangement.forEach(item => {
                    let tableSelected = item.getSelected()
                    if (hasError) {
                        return
                    }
                    if (tableSelected.length) {
                        selecteds = selecteds.concat(tableSelected)
                        let itemParam = item.collectionsSelectedData()
                        let mapKey = {}
                        if (itemParam) {
                            list = list.concat(itemParam)
                            itemParam.forEach(one => {
                                let isExist = !!mapKey[`key-${one.resumePositionId}-${one.turn}`]
                                if (isExist) {
                                    hasError = true
                                    tips = '同一个应聘者，面试阶段不能重复'
                                } else {
                                    mapKey[`key-${one.resumePositionId}-${one.turn}`] = true
                                }
                            })
                        } else {
                            hasError = true
                        }
                    }
                })
                if (selecteds.length === 0) {
                    this.$message({
                        message: '请勾选面试阶段',
                        type: 'warning'
                    })
                    return false
                }
                if (!hasError) {
                    if (list.length === 0) {
                        this.$message({
                            message: '除去不可更改的记录，当前无可保存的面试阶段',
                            type: 'warning'
                        })
                        return false
                    }
                    this.$axios.post('/resumePosition/interviewArrange/insertMutil.api', {
                        interviewArranges: JSON.stringify(list)
                    }, {
                        'X-showMessage': true
                    }).then(res => {
                        // 如果存在批量创建面试失败，则只更新保存成功的面试，否则请求所有数据整体更新
                        if (res.result.failList && res.result.failList.length) {
                            const { failList, sucessList } = res.result 
                            this.$message({
                                message: `${sucessList.length}场创建成功；${failList.length}场创建失败，请重新尝试`,
                                type: 'warning'
                            })
                            
                            this.$refs.arrangement.forEach(item => {
                                item.tableData.forEach(tableItem => {
                                    const successItem = sucessList.find(s => {
                                        return s.id === tableItem.id
                                    })
                                    if (successItem) {
                                        this.$set(tableItem, 'isEdit', false)
                                        item.setFormData(tableItem, successItem)
                                        item.sortByTurn()
                                        item.$forceUpdate()
                                    }
                                })
                            })
                        } else {
                            this.getData()
                        }
                    })
                } else {
                    tips && this.$message({
                        message: tips,
                        type: 'warning'
                    })
                }
            },
            sendEmail (type) {
                let selecteds = [], rpIds = [], ids = [], needWarn = false, unsafeDataCounter = 0, that = this
                this.$refs.arrangement.forEach(item => {
                    let tableSelected = item.getSelected()
                    if (tableSelected.length) {
                        let curTableRows = []
                        tableSelected.forEach(rowItem => {
                            if (rowItem.isEdit === true) {
                                needWarn = true
                                unsafeDataCounter++
                            } else {
                                curTableRows.push(rowItem)
                            }
                        })
                        if (curTableRows.length) {
                            selecteds = selecteds.concat(curTableRows)
                            rpIds.push(item.rpId)
                            ids.push(curTableRows[0].id)
                        }
                    }
                })
                if (selecteds.length === 0) {
                    this.$message({
                        message: '请勾选面试阶段',
                        type: 'warning'
                    })
                    return false
                }
                if (needWarn) {
                    this.$confirm(unsafeDataCounter + '条数据未保存, 继续操作将忽略未保存的数据，是否继续?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        notify()
                    }).catch(() => {
                    })
                } else {
                    notify()
                }

                function notify () {
                    let users = {}
                    selecteds.forEach((item, index) => {
                        let masterIds = item.masterInterviewer.split(','),
                            masterNames = item.masterInterviewerNames.split('，'),
                            interviewIds = item.interviewer.split(','),
                            interviewNames = item.interviewerNames.split('，')
                        item.interviewerUsers = []
                        if (item.masterInterviewer !== '') {
                            masterIds.forEach((mid, mindex) => {
                                users[mid] = masterNames[mindex]
                                item.interviewerUsers.push({
                                    id: mid,
                                    name: masterNames[mindex]
                                })
                            })
                        }
                        if (item.interviewer !== '') {
                            interviewIds.forEach((iid, iindex) => {
                                users[iid] = interviewNames[iindex]
                                item.interviewerUsers.push({
                                    id: iid,
                                    name: interviewNames[iindex]
                                })
                            })
                        }
                    })
                    let list = []
                    rpIds.forEach(id => {
                        list.push(_.findWhere(that.listData, {rpId: +id}))
                    })
                    that.$refs.sendEmail.show({
                        ids: rpIds.join(','),
                        interviewIds: ids.join(','),
                        resumePositionList: list,
                        phase: 2,
                        selecteds: selecteds,
                        userAttributes: type,
                        showInterviewPhase: type !== 4
                    })
                }
            }
        }
    }
</script>
<style type="text/css" lang="scss">
    @import "~style/app/arrangement.scss";

</style>
<style lang="scss" scoped>
    .scope-arrangements {
        margin-bottom : 50px;
        .multi-setting {
            border-top : 1px solid #ddd;
            margin-top : 15px;
            .label {
                font-weight : bold;
                margin      : 5px;
            }
            .betch {
                display        : flex;
            }
            .betch-left {
                flex           : 1;
                max-width      : 200px;
                margin-right   : 5px;
                display        : inline-block;
            }
            .betch-btn {
                background     : url("./betch-btn.png") no-repeat center center;
                flex           : 0 0 40px;
                width          : 40px;
                height         : 36px;
                display        : inline-block;
                vertical-align : bottom;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// arrangements.vue?5fdebce9